<template>
  <v-layout>
    <v-btn
      v-if="!menu"
      small
      icon
      outline
      :color="labelColor"
      @click="openMenu"
    >
      <span :color="labelColor">{{ index + 1 }}</span>
    </v-btn>
    <v-menu
      v-else
      v-model="menu"
      bottom
      offset-y
      :disabled="disabled"
    >
      <template v-slot:activator="{ on }">
        <v-btn
          small
          icon
          outline
          :color="labelColor"
          v-on="unloadingPlaces.length === 0 ? null : on"
        >
          <span :color="labelColor">{{ index + 1 }}</span>
        </v-btn>
      </template>
      <v-list dense>
        <div
          v-for="(unloadingPlace, i) in unloadingPlaces"
          :key="i"
        >
          <v-list-tile
            color="grey darken-2"
            @click="change(unloadingPlace)"
          >
            <UnloadingPlaceNumber :value="unloadingPlace.index + 1" />
          </v-list-tile>
        </div>
      </v-list>
    </v-menu>
  </v-layout>
</template>

<script>
import UnloadingPlaceNumber from "./UnloadingPlaceNumber.vue";
export default {
  components: {
    UnloadingPlaceNumber,
  },
  props: ["item"],
  data() {
    return {
      menu: false,
    };
  },
  computed: {
    unloadingPlaces() {
      const places = this.$store.getters["route/unloadingPlaces"].slice();
      places.forEach((place, index) => {
        place.index = index;
      });

      if (this.index === -1) {
        return places;
      }

      places.splice(this.index, 1);
      return places;
    },
    disabled() {
      return this.item.unloaded;
    },
    index() {
      const places = this.$store.getters["route/unloadingPlaces"].slice();
      const currentPlace = places.find(i => {
        return i.id === this.item.unloadingPlaceId;
      });
      return places.indexOf(currentPlace);
    },
    labelColor() {
      const places = this.$store.getters["route/unloadingPlaces"].slice();
      const unloadingPlace = places.find(i => {
        return i.id === this.item.unloadingPlaceId;
      });
      if (
        this.item.arrivalAddress?.id === unloadingPlace?.unloadingAddress?.id
      ) {
        return "green";
      } else {
        return "red";
      }
    },
  },
  methods: {
    change(unloadingPlace) {
      const routeItem = { ...this.item };
      routeItem.unloadingPlaceId = unloadingPlace.id;
      this.$store.commit("route/setEditableRouteItem", routeItem);
      this.$emit("unloadingPlaceChange");
    },
    openMenu() {
      if (!this.unloadingPlaces.length) {
        return;
      }
      this.menu = true;
    },
  },
};
</script>
